module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/error/lingerie-16f4675fef0754e8a7052802be872544.jpg";